const tokens = {
  colors: {
    light: {
      'bg-default': 'white',
      'bg-secondary': 'grey.200',
    },
    dark: {
      'bg-default': 'grey.700',
      'bg-secondary': 'grey.600',
    },
  },
};

const semanticTokens = {
  colors: {
    'primary-color': {
      default: 'grey.800',
    },
    'primary-text-color': {
      default: 'grey.700',
    },
    'color-text-primary': {
      default: 'grey.700',
    },
    'color-text-secondary': {
      default: 'grey.400',
    },
    'secondary-text-color': {
      default: 'grey.400',
    },
    'primary-blue': {
      default: 'primary-blue.500',
      // _dark: tokens.colors.dark['bg-default'],
    },
    'primary-green': {
      default: '#0067D8',
      // _dark: tokens.colors.dark['bg-default'],
    },
    'body-bg': {
      default: 'white',
      // _dark: tokens.colors.dark["bg-secondary"],
    },
    'bg-secondary': {
      default: tokens.colors.light['bg-secondary'],
      _dark: tokens.colors.dark['bg-secondary'],
    },
    'text-title': {
      default: 'grey.600',
      _dark: 'grey.200',
    },
    'text-content': {
      default: 'grey.600',
      _dark: 'grey.200',
    },
    'text-primary-color': {
      default: 'grey.700',
    },
    'text-secondary-color': {
      default: 'grey.400',
      _dark: 'grey.200',
    },
    'input-bg': {
      default: '#F3F4F9',
      _dark: '#F3F4F9',
    },
    'content-bg': {
      default: '#F3F4F9',
      _dark: '#F3F4F9',
    },
    'icon-button-bg': {
      default: '#F3F4F9',
      _dark: '#F3F4F9',
    },
    'btn-primary-bg': {
      default: 'primary-color',
      _dark: 'primary-color',
    },
    'btn-primary-text': {
      default: 'white',
      _dark: 'grey.600',
    },
    'btn-primary-pressed-bg': {
      default: 'grey.600',
      _dark: 'grey.600',
    },
    'btn-primary-pressed-text': {
      default: 'orange.500',
      _dark: 'orange.500',
    },
    'btn-disabled-bg': {
      default: 'grey.300',
      _dark: 'grey.300',
    },
    'color-page-bg-primary': {
      default: '#FFFFFF',
      _dark: '',
    },
    'color-section-bg-primary-normal': {
      default: '#F7F7F7',
      _dark: '',
    },
    'color-section-bg-primary-selected': {
      default: '#EDEDED',
      _dark: '',
    },
    'color-section-bg-primary-divider': {
      default: '#E9E9E9',
      _dark: '',
    },
    'color-payment-option-bg': {
      default: '#F5F7FA',
      _dark: '',
    },
    'color-check': {
      default: '#15DD73',
      _dark: '',
    },
    'color-input-border-active': {
      default: 'grey.700',
      _dark: '',
    },
  },
  radii: {
    cardLg: '50px',
    cardMd: '20px',
    'radii-button': '10px',
  },
  sizes: {
    containerMd: '650px',
    // "button-sm": "100px",
    // "button-md": "150px",
    // "button-lg": "200px",
  },
};

export default semanticTokens;
